module.exports = __webpack_public_path__ + "img/page3-content.8a31e614.jpg";